import { Injectable } from '@angular/core'

import { Yritysmuoto } from '@lemon/core-firebase/model/kayttaja'
import { TilinpaatosUserData } from '@lemon/core-firebase/model/tilinpaatos'
import { TilinpaatosUriService } from '@lemon/core-firebase/service/tilinpaatos-uri.service'
import { combineLatest, Observable, of as observableOf, switchMap } from 'rxjs'
import { FirebaseLemonaid } from './firebase-lemonaid.service'
import { KayttajaService } from './kayttaja.service'

@Injectable()
export class TilinpaatosLemonaidUsersService {
  tilinpaatosUsersObservable: Observable<TilinpaatosUserData>

  constructor(
    private _firebaseLemonaid: FirebaseLemonaid,
    private _tilinpaatosUriService: TilinpaatosUriService,
    private _kayttajaService: KayttajaService,
  ) {
    this.tilinpaatosUsersObservable = combineLatest([this._kayttajaService.nykyinenAsiakasObservable, this._kayttajaService.kayttajaObservable]).pipe(
      switchMap(([asiakas, kayttaja]) => {
        if (!kayttaja || !asiakas) {
          return observableOf<TilinpaatosUserData>(null)
        }
        if (asiakas.yritysmuoto === Yritysmuoto.TOIMINIMI) {
          return observableOf<TilinpaatosUserData>(null)
        }
        if (kayttaja.kayttajaTunnistettu === 'tunnistettu-nets') {
          return this._firebaseLemonaid.firestoreDoc<TilinpaatosUserData>(this._tilinpaatosUriService.getTilinpaatosUsersDocUri(asiakas.asiakasAvain)).listen()
        }
        return observableOf<TilinpaatosUserData>(null)
      }),
    )
  }
}
